export const holidayAssignmentModes = {
  every: "Every Year",
  alternate: "Alernate Years",
};
export type HolidayAssignmentMode = keyof typeof holidayAssignmentModes;
